import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation DeleteRegistrationFormField($formId: Int!, $id: Int!) {
    deleteRegistrationFormField(formId: $formId, id: $id) {
      id
    }
  }
`;
